import { FC, PropsWithChildren } from 'react';

import { HttpError } from '@bonusly/http';
import { useFeatureFlag } from '@bonusly/who-am-i';

interface FlaggedRouteProps extends PropsWithChildren {
	variant: string;
}

export const FlaggedRoute: FC<FlaggedRouteProps> = ({ children, variant }) => {
	const isEnabled = useFeatureFlag(variant);

	if (isEnabled) {
		return <>{children}</>;
	}

	throw new HttpError(404);
};
